import { useListInsurancesQuery } from '@api'
import { Button, Flexbox, Radio, Spacer, Text } from '@components/common'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import FilterLoading from './FilterLoading'
import { AssetsTableFilterField } from './Filters.types'

interface Props {
  filter: AssetsTableFilterField
}

const InsurancesFilter = ({ filter }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const searchParamsObject = Object.fromEntries([...searchParams])

  const [value, setValue] = useState<string | undefined>(
    searchParams.get(filter.column) ?? undefined
  )

  const inputChangeTimeoutDuration: number = 400

  const {
    data: insurances,
    isLoading: isLoadingInsurances,
    isError: isErrorGettingInsurances,
  } = useListInsurancesQuery()

  function onChange(e: any) {
    setValue(e.target.value)
    setTimeout(() => {
      if (e.target.value === '') {
        searchParams.delete(e.target.name)
        setSearchParams(searchParams)
      } else {
        setSearchParams({
          ...searchParamsObject,
          [e.target.name]: (e.target.value = typeof Number
            ? e.target.value.toString()
            : e.target.value),
          pageNumber: '1',
        })
      }
    }, inputChangeTimeoutDuration)
  }

  function clearSelection() {
    searchParams.delete(filter.column)
    setSearchParams(searchParams)
    setValue(undefined)
  }

  if (isErrorGettingInsurances) {
    return <Text intent="danger">Error getting insurances.</Text>
  }

  if (isLoadingInsurances) {
    return <FilterLoading />
  }

  if (insurances.length === 0) {
    return <Text>You haven't added any depreciation profiles yet.</Text>
  }

  return (
    <div>
      <Spacer y="mini" />
      <Radio name={filter.column} onChange={onChange} select={value} legend="">
        {insurances.map((policy, index: number) => (
          <Radio.Option
            value={policy.ID}
            label={`${policy.ID} (${policy.Name})`}
            autoFocus={index === 0}
            key={policy.ID}
          />
        ))}
      </Radio>
      <Spacer y="mini" />
      <Flexbox justifyContent="flex-end">
        <Text small>
          <Button
            onClick={() => clearSelection()}
            appearance="text"
            disabled={value === '' || value === undefined}
          >
            Clear
          </Button>
        </Text>
      </Flexbox>
    </div>
  )
}
export default InsurancesFilter
